import React, { memo } from 'react';

// Types
import { ReferencePatternName } from 'Shared/types/BaInfo.types';

// Components
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';

type Props = {
  className?: string;
  alt?: string;
  referencePattern: ReferencePatternName;
};

const ReferencePatternIcon = ({ referencePattern, alt, className }: Props) => {
  const getIllustration = () => {
    switch (referencePattern) {
      case ReferencePatternName.adapter:
        return Illustrations.reference_profile_adapter;
      case ReferencePatternName.altruist:
        return Illustrations.reference_profile_altruist;
      case ReferencePatternName.analyzer:
        return Illustrations.reference_profile_analyzer;
      case ReferencePatternName.artisan:
        return Illustrations.reference_profile_artisan;
      case ReferencePatternName.captain:
        return Illustrations.reference_profile_captain;
      case ReferencePatternName.collaborator:
        return Illustrations.reference_profile_collaborator;
      case ReferencePatternName.controller:
        return Illustrations.reference_profile_controller;
      case ReferencePatternName.craftsman:
        return Illustrations.reference_profile_craftsman;
      case ReferencePatternName.guardian:
        return Illustrations.reference_profile_guardian;
      case ReferencePatternName.maverick:
        return Illustrations.reference_profile_maverick;
      case ReferencePatternName.individualist:
        return Illustrations.reference_profile_individualist;
      case ReferencePatternName.operator:
        return Illustrations.reference_profile_operator;
      case ReferencePatternName.persuader:
        return Illustrations.reference_profile_persuader;
      case ReferencePatternName.promoter:
        return Illustrations.reference_profile_promoter;
      case ReferencePatternName.scholar:
        return Illustrations.reference_profile_scholar;
      case ReferencePatternName.specialist:
        return Illustrations.reference_profile_specialist;
      case ReferencePatternName.strategist:
        return Illustrations.reference_profile_strategist;
      case ReferencePatternName.venturer:
        return Illustrations.reference_profile_venturer;

      default:
        return null;
    }
  };

  if (!referencePattern) return null;
  return <WpIllustration className={className} src={getIllustration()} alt={alt} />;
};

export default memo(ReferencePatternIcon);
